module.exports = __webpack_public_path__ + "img/jameson-form-bg.1911d9a0.png";